import { useState } from 'react'
import {
  Box,
  Button,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Paper,
  Popper,
  MenuList,
  Grow,
  ClickAwayListener,
  Stack,
} from '@mui/material'
import * as Icons from '@mui/icons-material'
import { ReportModal } from '~/reports/report-modal'

export const ReportMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [showReportModal, setShowReportModal] = useState(false)

  const open = Boolean(anchorEl)

  const handleAction = (setModal) => {
    setAnchorEl(null)
    setModal(true)
  }

  return (
    <Stack>
      <Button
        // onClick={!anyModalOpen ? (e) => setAnchorEl(e.currentTarget) : undefined}
        onClick={() => handleAction(setShowReportModal)}
        startIcon={<Icons.ContentPasteSearch fontSize="small" />}
        aria-controls={open ? 'add-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        Report
      </Button>
      <ReportModal open={showReportModal} onClose={() => setShowReportModal(false)} />
    </Stack>
  )
}
